"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _iterables = require("../../utils/iterables");

var _popover = require("../../constants/popover");

var _withLinkState = _interopRequireDefault(require("../links/withLinkState"));

var _EditImagePopoverBody = _interopRequireDefault(require("./EditImagePopoverBody"));

var _EditImagePopoverPreview = _interopRequireDefault(require("./EditImagePopoverPreview"));

var EditImagePopoverBranch = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EditImagePopoverBranch, _Component);

  function EditImagePopoverBranch() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, EditImagePopoverBranch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(EditImagePopoverBranch)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleClose = function () {
      _this.props.onClose();

      _this.props.onModeChange(_popover.PopoverBodyMode.PREVIEW);
    };

    _this.handleEdit = function () {
      _this.props.onModeChange(_popover.PopoverBodyMode.EDIT);
    };

    return _this;
  }

  (0, _createClass2.default)(EditImagePopoverBranch, [{
    key: "renderPopoverPreview",
    value: function renderPopoverPreview() {
      var previewImageProps = (0, _iterables.omit)(['onEdit'], (0, _iterables.pick)(Object.keys(_EditImagePopoverPreview.default.propTypes), this.props));
      return _react.default.createElement(_EditImagePopoverPreview.default, Object.assign({
        key: "hs-image-preview"
      }, previewImageProps, {
        onEdit: this.handleEdit
      }));
    }
  }, {
    key: "renderPopoverEdit",
    value: function renderPopoverEdit() {
      var editImageProps = (0, _iterables.pick)(Object.keys(_EditImagePopoverBody.default.propTypes), this.props);
      return _react.default.createElement(_EditImagePopoverBody.default, Object.assign({
        key: "hs-popover-edit"
      }, editImageProps, {
        onClose: this.handleClose
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "hs-link-popover-edit"
      }, this.props.mode === _popover.PopoverBodyMode.PREVIEW ? this.renderPopoverPreview() : this.renderPopoverEdit());
    }
  }]);
  return EditImagePopoverBranch;
}(_react.Component);

var _default = (0, _withLinkState.default)(EditImagePopoverBranch);

exports.default = _default;
EditImagePopoverBranch.propTypes = Object.assign({
  mode: _propTypes.default.string.isRequired,
  onModeChange: _propTypes.default.func.isRequired
}, (0, _iterables.omit)(['onEdit'], _EditImagePopoverPreview.default.propTypes), {}, _EditImagePopoverBody.default.propTypes);
module.exports = exports.default;